import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styles: []
})
export class FormComponent implements OnInit {

	@Input('config') config:any = {};
	// @Output('submit') submit:EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  public getModelValue(key, obj) {
  	return obj[key];
  }

  public getErrors(config:any, field){
    if (config.hasOwnProperty('errors')) {
      let errors = Object.keys(config.errors).filter(o => o == field.modelKey )
      if (errors.length) {
        return errors[0]
      } 
      return [];
    }
  }

  public setNestedValue(path, value, obj) {
      let pList = path.split('.');
      let len = pList.length;

      for(let i = 0; i < len-1; i++) {
          let elem = pList[i];
          if( !obj[elem] ) obj[elem] = {}
          obj = obj[elem];
      }

      obj[pList[len-1]] = value;
  }

  public setValue($event, obj, key, callback = (o)=>{}) {
    if (key.indexOf('.')) {
      this.setNestedValue(key, $event, obj)
    } else {
      obj[key] = $event;
    }
    callback(obj);
  }

  public conditionalLogic(field, obj){
    if (field.hasOwnProperty('conditionalLogic')) {
      return field.conditionalLogic.value === obj[field.conditionalLogic.key];
    }
    return true;
  }

  preventSubmit(event) {
  	event.preventDefault();
  }

  submit() {
  	this.config.submit.action(this.config.obj)
  }

}



// WEBPACK FOOTER //
// ./src/app/vqforms/form.component.ts